import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "@/assets/scss/material-kit.scss";
import "@/assets/demo.css";
import "@/assets/scss/aer.scss";
import globalDirectives from "./globalDirectives";
import globalMixins from "./globalMixins";
import basicMixins from "./basicMixins";
import globalComponents from "./globalComponents";
import VueLazyload from "vue-lazyload";
import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";
import Notifications from "@/components/NotificationPlugin";

// library auto imports
import "es6-promise/auto";

export default {
    install(Vue) {
        Vue.use(VueMaterial);
        Vue.use(globalDirectives);
        Vue.use(globalMixins);
        Vue.use(basicMixins);
        Vue.use(globalComponents);
        Vue.use(VueLazyload, {
            observer: true,
            // optional
            observerOptions: {
                rootMargin: "0px",
                threshold: 0.1
            }
        });
        Vue.use(VueGitHubButtons, { useCache: false });
        Vue.use(Notifications);
    }
};
